import React from 'react';
import { FormattedMessage } from 'react-intl';
import PhoneNumberFieldMobile from './phoneNumberFieldMobile';
import EmailEmailFieldMobile  from './emailFieldMobile';
import MarketingConsentMobile from '../marketingConsentMobile';
import { useSelector } from 'react-redux';


const PersonalDetailsMobile = () => {

  const { country_code } = useSelector((state: any) => state.company);

  return (
    <div className="personal-details-mobile-wrapper">
      <p className="section-heading">
        <FormattedMessage
          id="my_account.personal_details"
          defaultMessage="Personal Details"
        />
      </p>

      <div className="personal-details-mobile">
        <PhoneNumberFieldMobile />
        <EmailEmailFieldMobile />
        {country_code === "SG" && <MarketingConsentMobile />}
      </div>
    </div>
  );
};

export default PersonalDetailsMobile;
